import { useMutation, useQueryClient } from "@tanstack/react-query";

import useGetAccessToken from "components/Login/useGetAccessToken";
import type { Task } from "types/Task";
import { applyServerTaskRow } from "types/Task";
import {
  claimTerminalTask,
  type ClaimTerminalResult,
} from "../methods/claimTerminalTask";
import { TASKS_QUERY_KEY } from "./useTasksQuery";

// Included in the focus-refetch guard alongside PATCH_TASK_MUTATION_KEY.
export const CLAIM_TERMINAL_MUTATION_KEY = ["cc-db-api", "claimTerminalTask"];

/**
 * Claims the terminal-directive slot. Updates the cached row in place on
 * success. When the row is gone (404), `task` is undefined.
 */
export default function useClaimTerminalTaskMutation() {
  const getAccessToken = useGetAccessToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: CLAIM_TERMINAL_MUTATION_KEY,
    mutationFn: (id: string) => claimTerminalTask(id, getAccessToken),
    onSuccess: (data: ClaimTerminalResult) => {
      const task = data.task;
      if (!task) return;
      queryClient.setQueryData<Task[]>(TASKS_QUERY_KEY, (prev) =>
        prev?.map((j) => (j.id === task.id ? applyServerTaskRow(j, task) : j))
      );
    },
  });
}
